export default __webpack_public_path__ + "static/media/leftVector.f088b0ab.svg";